
const header_bar = document.querySelector(".ante-announcement-bar-section")
const header = document.querySelector(".ante-header-section")
let lastScrollTop = 0; // 记录上一次滚动位置
if (header_bar.getBoundingClientRect().top === 0) {
    header_bar.style.transform = "translateY(0)";
}
const faq_arr = document.querySelectorAll('.faq-simple')

function adjsutFaqPadding() {
    if (faq_arr.length > 0) {
        faq_arr.forEach(element => {
            const img = element.querySelector(".ante-bottom-image")
            if (img) {
                element.style.paddingBottom = (img.clientHeight - 100) + "px"
            }
        });
    }
}
window.addEventListener("load", adjsutFaqPadding);


window.addEventListener("resize", adjsutFaqPadding);

window.addEventListener("scroll", () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    header_bar.style.transform = null;

    if (scrollTop > lastScrollTop) {
        // 向下滚动
        header_bar.classList.remove("ante-announcement-bar-sticky");
        header.classList.remove("ante-header-sticky");
    } else {
        // 向上滚动
        header_bar.classList.add("ante-announcement-bar-sticky");
        header.classList.add("ante-header-sticky");
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // 防止负值
});

document.addEventListener("DOMContentLoaded", function () {
    class AnteDialog extends HTMLElement {
        constructor() {
            super();
            this.isOpen = false; // 记录弹窗是否打开
        }

        connectedCallback() {
            this.dialog = this.querySelector('.ante-dialog-box');
            this.content = this.querySelector('.ante-dialog-content');

            this.addEventListener("click", (e) => {
                if (e.target === this) {
                    this.closeDialog();
                }
            });
        }

        openDialog(video) {
            if (this.content.contains(this.content.firstChild)) {
                this.content.removeChild(this.content.firstChild);
            }

            this.content.appendChild(video)

            if (this.content.firstChild.querySelector("video") && this.content.firstChild.querySelector("video").tagName === "VIDEO") {
                this.content.firstChild.querySelector("video").currentTime = 0;
                this.content.firstChild.querySelector("video").play()
            }
            // 显示弹窗
            this.style.display = "flex";
            this.isOpen = true;
            document.body.style.overflow = 'hidden';
        }

        closeDialog() {
            this.content.innerHTML = "";
            this.style.display = "none";
            this.isOpen = false;
            document.body.style.overflow = '';
        }
    }
    // 定义自定义元素 ante-dialog
    if (!window.customElements.get("ante-dialog")) {
        window.customElements.define("ante-dialog", AnteDialog);
    }

    class AnteDialogTemplate extends HTMLElement {
        connectedCallback() {
            this.openTempDialog()
        }
        openTempDialog() {
            const dialog = document.querySelector('ante-dialog')
            const temp = this.querySelector(".dialogTemp").content
            const clone = document.importNode(temp.querySelector(".tmp-box"), true);
            this.querySelector(".ante-open-dialog").addEventListener("click", function () {
                dialog.openDialog(clone)
            })
        }

    }
    // 定义自定义元素 ante-dialog
    if (!window.customElements.get("ante-dialog-template")) {
        window.customElements.define("ante-dialog-template", AnteDialogTemplate);
    }

    class AnteReview extends HTMLElement {
        connectedCallback() {
            this.AnteSwiper()
        }
        AnteSwiper() {
            const swiper = this.querySelector(".swiper")
            const row = this.dataset.row
            new Swiper(swiper, {
                loop: true,
                slidesPerView: row,
                spaceBetween: 20,
                breakpoints: {
                    1200: {
                        slidesPerView: row,
                        spaceBetween: 20,
                    },
                    1024: {
                        slidesPerView: 3,
                        spaceBetween: 15,
                    },
                    300: {
                        slidesPerView: 2,
                        spaceBetween: 10,
                    },
                },
                pagination: {
                    el: '.swiper-pagination',  // 分页容器
                    clickable: true,  // 使分页点击有效
                },
                navigation: {
                    nextEl: '.swiper-button-next',  // 下一页按钮
                    prevEl: '.swiper-button-prev',  // 上一页按钮
                },
            })
        }

    }
    if (!window.customElements.get("ante-review")) {
        window.customElements.define("ante-review", AnteReview);
    }

    class ANTEFAQ extends HTMLElement {
        connectedCallback() {
            this.AnteFaq()
        }
        AnteFaq() {
            const box = this.querySelector(".accordion")
            const arr = box.querySelectorAll(".accordion__item")
            arr.forEach(el => {
                el.querySelector("button").addEventListener("click", function (e) {
                    if (!el.classList.contains("is-active") && e.target.getAttribute("aria-expanded") != "true") {
                        arr.forEach(li => {
                            const btn = li.querySelector("button")
                            const content = li.querySelector(".accordion__content")
                            btn.setAttribute("aria-expanded", false)
                            li.classList.remove("is-active")
                            content.style.height = content.scrollHeight + "px";
                            content.offsetHeight;
                            content.style.height = "0";
                        })
                    }
                })
            })
        }
    }
    if (!window.customElements.get("ante-faq")) {
        window.customElements.define("ante-faq", ANTEFAQ);
    }

    class AnteAddToCart extends HTMLElement {
        connectedCallback() {
            this.AnteAddToCard()
        }
        AnteAddToCard() {
            const addtocard = document.querySelector(".product-add-to-cart .add-to-cart")
            this.addEventListener("click", function () {
                if (addtocard) {
                    addtocard.click()
                }

            })
        }
    }
    if (!window.customElements.get("ante-add-to-cart")) {
        window.customElements.define("ante-add-to-cart", AnteAddToCart);
    }

    class AnteMaterialList extends HTMLElement {
        connectedCallback() {
            this.AnteSwper()
        }
        AnteSwper() {
            const swiper = this.querySelector(".swiper")
            const wrapper = this.querySelector('.swiper-wrapper');
            const slides = wrapper.querySelectorAll('.swiper-slide');

            if (slides.length < 5) {
                slides.forEach(slide => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('swiper-slide-duplicate');
                    wrapper.appendChild(clone);
                });
            }

            new Swiper(swiper, {
                loop: true,
                slidesPerView: 3,
                centeredSlides: true,
                spaceBetween: 40,
                breakpoints: {
                    1400: {
                        slidesPerView: 3,
                        spaceBetween: 40,
                    },
                    1200: {
                        slidesPerView: 2.8,
                        spaceBetween: 40,
                    },
                    1000: {
                        slidesPerView: 2.4,
                        spaceBetween: 40,
                    },
                    768: {
                        slidesPerView: 2.2,
                        spaceBetween: 30,
                    },
                    300: {
                        slidesPerView: 1.4,
                        spaceBetween: 20,
                    }
                },
                navigation: {
                    nextEl: '.swiper-button-next',  // 下一页按钮
                    prevEl: '.swiper-button-prev',  // 上一页按钮
                }
            })
        }
    }
    if (!window.customElements.get("ante-material-list")) {
        window.customElements.define("ante-material-list", AnteMaterialList);
    }

    class QUICKMODEL extends HTMLElement {
        connectedCallback() {
            this.OpenDialog();
        }

        OpenDialog() {
            const dialog = document.getElementById("quick-model-dialog");
            const closeBtn = dialog.querySelector(".quick-model-close");
            const product_id = this.dataset.productId
            const body = document.querySelector("body")

            // 打开弹窗
            this.querySelector(".quick-btn").addEventListener("click", () => {
                this.fetchProductData(product_id)
                setTimeout(() => {
                    dialog.classList.add("show");
                    body.style.overflow = "hidden"

                }, 1000)
            });

            // 关闭弹窗
            closeBtn.addEventListener("click", () => {
                dialog.classList.remove("show");
                body.style.overflow = "auto"
                const box = document.querySelector("#quick-model-dialog .quick-model-content .quick-model-body")
                box.innerHTML = "";
            });

            // 点击遮罩关闭
            dialog.addEventListener("click", (e) => {
                if (e.target === dialog) {
                    dialog.classList.remove("show");
                    body.style.overflow = "auto"
                    const box = document.querySelector("#quick-model-dialog .quick-model-content .quick-model-body")
                    box.innerHTML = "";
                }
            });
        }
        async fetchProductData(handle) {
            const res = await fetch(`/products/${handle}`)
            const html = await res.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, "text/html");
            const box = document.querySelector("#quick-model-dialog .quick-model-content .quick-model-body")
            const content = doc.querySelector("#MainContent").children[2];
            const sectionId = doc.querySelector("#MainContent").children[2].querySelector("section").dataset.sectionId
            const scripts = doc.querySelectorAll("script");
            if (window.themeCore.Product != undefined) {
                const a = window.themeCore.Product
                a.init(sectionId)
                const lazyImage = window.themeCore.LazyLoadImages
                lazyImage.init()
                setTimeout(() => {
                    lazyImage.init()
                }, 100)
            }
            if (content) {
                doc.querySelectorAll("script").forEach(script => {
                    if ((script.type && script.type !== "text/javascript" && script.type !== "") || (script.src && script.src.includes("shopify-perf-kit"))) {
                        return; // 跳过 JSON、模板或 PerfKit 脚本
                    }
                    script.remove()
                });

                box.appendChild(content.cloneNode(true));
            }
            scripts.forEach(script => {
                if ((script.type && script.type !== "text/javascript" && script.type !== "") || (script.src && script.src.includes("shopify-perf-kit"))) {
                    return; // 跳过 JSON、模板或 PerfKit 脚本
                }
                const newScript = document.createElement("script");
                if (script.src) {
                    newScript.src = script.src;
                    newScript.async = false;
                    box.appendChild(newScript);
                }
            });
        }
    }

    if (!window.customElements.get("quick-model")) {
        window.customElements.define("quick-model", QUICKMODEL);
    }

    class ANTESYNCSWiper extends HTMLElement {
        connectedCallback() {
            this.AnteSwiper()
        }
        AnteSwiper() {
            const swiper_box1 = this.querySelector(".ante-bg-swiper")
            const swiper_box2 = this.querySelector(".ante-info-swiper")
            const swiper_box3 = this.querySelector(".ante-product-swiper")
            const swiper_pagination = this.querySelector(".ante-product-swiper  .swiper-pagination")
            const swiper1 = new Swiper(swiper_box1, {
                loop: true,
                slidesPerView: 1,
                speed: 500
            })

            const swiper2 = new Swiper(swiper_box2, {
                loop: true,
                slidesPerView: 1,
                speed: 500
            })

            const swiper3 = new Swiper(swiper_box3, {
                loop: true,
                slidesPerView: 1,
                effect: "fade",
                speed: 500,
                fadeEffect: {
                    crossFade: true, // 淡入淡出效果
                },
                pagination: {
                    el: swiper_pagination,
                    clickable: true
                },
                navigation: {
                    nextEl: '.swiper-button-next',  // 下一页按钮
                    prevEl: '.swiper-button-prev',  // 上一页按钮
                }
            })
            swiper1.controller.control = swiper3;
            swiper3.controller.control = swiper1;

            swiper1.on("slideChangeTransitionStart", () => {
                swiper2.slideTo(swiper1.realIndex)
            })
            swiper3.on("slideChangeTransitionStart", () => {
                swiper2.slideTo(swiper3.realIndex)
            })

            const btns = this.querySelector(".ante-product-swiper-box .ante-swiper-container")
            btns.querySelector(".ante-swiper-button-next").addEventListener("click", function () {
                swiper1.slideNext()
            })
            btns.querySelector(".ante-swiper-button-prev").addEventListener("click", function () {
                swiper1.slidePrev()
            })
        }
    }
    if (!window.customElements.get("ante-sync-swiper")) {
        window.customElements.define("ante-sync-swiper", ANTESYNCSWiper);
    }

    class AnteTabs extends HTMLElement {
        connectedCallback() {
            this.AnteTabs()
        }
        AnteTabs() {
            const tabnav = this.querySelectorAll("button.ante-tab")
            const tabCont = this.querySelectorAll(".ante-blinds")
            let isLocked = false

            tabnav.forEach(el => {
                el.addEventListener("click", function () {
                    if (isLocked) return
                    isLocked = true
                    setTimeout(() => isLocked = false, 1000)
                    const targetId = el.getAttribute("tab-id");

                    tabnav.forEach(btn => btn.classList.toggle("active", btn === el));

                    tabCont.forEach(item => {
                        if (targetId !== item.getAttribute("tab-id")) {
                            item.classList.remove("active")
                        }
                    })

                    setTimeout(() => {
                        tabCont.forEach(item => {
                            if (targetId === item.getAttribute("tab-id")) {
                                item.removeAttribute("hidden")
                            } else {
                                item.setAttribute("hidden", "")
                            }
                        })
                    }, 500)
                    setTimeout(() => {
                        tabCont.forEach(item => {
                            if (targetId === item.getAttribute("tab-id")) {
                                item.classList.add("active")
                            }
                        })
                    }, 600)
                })
            })
        }
    }
    if (!window.customElements.get("ante-tabs")) {
        window.customElements.define("ante-tabs", AnteTabs);
    }

    class AnteBinds extends HTMLElement {
        connectedCallback() {
            this.AnteBinds()
        }
        AnteBinds() {
            const btns = this.querySelector(".ante-blinds-button")
            const cont = this.querySelector(".ante-desciption-content")
            const _this = this
            btns.addEventListener("click", function () {
                if (!_this.hasAttribute("open")) {
                    const max_height = cont.scrollHeight + "px"
                    cont.style.setProperty("--ante-max-height", max_height);
                    _this.setAttribute("open", "")
                } else {
                    cont.style.setProperty("--ante-max-height", "0px");
                    _this.removeAttribute("open")
                }
            })
        }
    }
    if (!window.customElements.get("ante-blinds")) {
        window.customElements.define("ante-blinds", AnteBinds);
    }

    class AnteProductReview extends HTMLElement {
        connectedCallback() {
            this.handleResize = this.handleResize.bind(this);
            this.initSwiper = this.initSwiper.bind(this);
            this.cloneSlides = this.cloneSlides.bind(this);
            this.removeClones = this.removeClones.bind(this);

            this.wrapper = this.querySelector('.swiper-wrapper');
            this.swiperInstance = null;

            this.handleResize();
            window.addEventListener('resize', this.handleResize);
        }

        disconnectedCallback() {
            if (this.swiperInstance) this.swiperInstance.destroy(true, true);
            window.removeEventListener('resize', this.handleResize);
        }

        get originalSlides() {
            return this.wrapper.querySelectorAll('.swiper-slide:not(.swiper-slide-duplicate)');
        }

        hasClones() {
            return this.wrapper.querySelector('.swiper-slide-duplicate') !== null;
        }

        /**
         * ✅ 改进版 cloneSlides
         * 当原始数量小于 3 时，重复克隆到至少 3 张，保证 loop 正常。
         */
        cloneSlides() {
            if (this.hasClones()) return;

            const originals = Array.from(this.originalSlides);
            const origCount = originals.length;

            // 至少保证 3 张
            const times = Math.ceil(3 / origCount);

            for (let t = 0; t < times; t++) {
                originals.forEach((slide, i) => {
                    const clone = slide.cloneNode(true);
                    clone.classList.add('swiper-slide-duplicate');
                    clone.dataset.originalIndex = i;
                    this.wrapper.appendChild(clone);
                });
            }
        }

        removeClones() {
            this.wrapper.querySelectorAll('.swiper-slide-duplicate').forEach(clone => clone.remove());
        }

        initSwiper(loopEnabled) {
            if (this.swiperInstance) this.swiperInstance.destroy(true, true);

            const origCount = this.originalSlides.length;
            const slidesPerView = origCount <= 3 ? origCount : 3;

            this.swiperInstance = new Swiper(this, {
                loop: !!loopEnabled,
                slidesPerView,
                spaceBetween: 40,
                centeredSlides: !!loopEnabled,
                loopedSlides: this.originalSlides.length,
                breakpoints: {
                    750: { slidesPerView, spaceBetween: 40 },
                    480: { slidesPerView: 2.2, spaceBetween: 20 },
                    300: { slidesPerView: 1.4, spaceBetween: 20 },
                },
                pagination: {
                    el: ".swiper-pagination",
                    clickable: true,
                },
            });

            /** ✅ 隐藏多余 bullet（分页器只显示原始数量） */
            const bullets = this.querySelectorAll('.swiper-pagination-bullet');
            bullets.forEach((b, i) => {
                if (i >= origCount) b.style.display = 'none';
            });

            /** ✅ slide 切换时更新真实分页器 */
            const swiper = this.swiperInstance;
            swiper.on('slideChange', () => {
                const activeSlide = swiper.slides[swiper.activeIndex];
                let realIndex;

                if (activeSlide.classList.contains('swiper-slide-duplicate')) {
                    realIndex = parseInt(activeSlide.dataset.originalIndex);
                } else {
                    realIndex = swiper.realIndex;
                }

                const bullets = this.querySelectorAll('.swiper-pagination-bullet');
                bullets.forEach((b, i) =>
                    b.classList.toggle('swiper-pagination-bullet-active', i === realIndex)
                );
            });
        }

        handleResize() {
            clearTimeout(this._resizeTimer);
            this._resizeTimer = setTimeout(() => {
                const width = window.innerWidth;
                const origCount = this.originalSlides.length;

                if (width < 750) {
                    this.cloneSlides();
                    this.initSwiper(true);
                } else {
                    this.removeClones();
                    if (origCount <= 3) {
                        this.initSwiper(false);
                    } else {
                        this.initSwiper(true);
                    }
                }
            }, 150);
        }
    }

    if (!window.customElements.get("ante-product-review")) {
        window.customElements.define("ante-product-review", AnteProductReview);
    }


    class AnteaddCardBTN extends HTMLElement {
        connectedCallback() {
            this.AddTocard()
        }
        AddTocard() {
            const pr_card = this.parentElement.parentElement.parentElement.parentElement
            const add_card = pr_card.querySelector(".product-card__additional-buttons.ante-hidden")
            this.addEventListener("click", function () {
                add_card.querySelector("button").click()
            })
        }
    }

    if (!window.customElements.get("ante-add-card-btn")) {
        window.customElements.define("ante-add-card-btn", AnteaddCardBTN);
    }


    class AnteNewsletterCode extends HTMLElement {
        connectedCallback() {
            this.codeEl = this.querySelector(".ante-newsletter-code");
            this.copyBtn = this.querySelector("svg");
            this.copyBtn.style.cursor = "pointer";
            this.copyBtn.addEventListener("click", () => this.copyCode());
            this.enables = true;
        }

        copyCode() {
            const code = this.codeEl?.textContent?.trim();
            console.log("Copying code:", code);
            navigator.clipboard.writeText(code).then(() => {
                this.showCopied();
            });
        }

        showCopied() {
            let copiedEl = this.querySelector(".ante-copide");
            const _this = this;
            if (copiedEl && this.enables) {
                copiedEl.classList.add("active");
                _this.enables = false;
                setTimeout(() => {
                    copiedEl.classList.remove("active");
                    _this.enables = true;
                }, 2000);
            }
        }
    }

    if (!window.customElements.get("ante-newsletter-code")) {
        window.customElements.define("ante-newsletter-code", AnteNewsletterCode);
    }



    setTimeout(() => {
        header_bar.classList.add("with-transition");
    }, 1000)

    const product_arr = document.querySelectorAll('.accordion')
    if (product_arr.length > 0) {
        product_arr.forEach(element => {
            const btn = element.querySelector(".accordion-header")
            if (btn) [
                btn.addEventListener("click", function (e) {
                    const content = e.target.nextElementSibling;
                    // 先把其他都收起
                    product_arr.forEach(other => {
                        if (other !== element) {
                            const otherContent = other.querySelector(".accordion-content");
                            if (otherContent) {
                                otherContent.style.maxHeight = null;
                            }
                            other.classList.remove("open");
                        }
                    });

                    if (content.style.maxHeight) {
                        // 已展开 → 收起
                        content.style.maxHeight = null;
                        element.classList.remove('open');
                    } else {
                        // 收起 → 展开
                        content.style.maxHeight = content.scrollHeight + "px";
                        element.classList.add('open');
                    }
                })
            ]
        });
    }


})